import React from "react";
import { Home } from "lucide-react";
import TalentDirectory from "./TalentDirectory";

function HomeTutors() {
    return (
        <TalentDirectory
            title="Hire Home Tutors"
            subtitle="One-to-one tutors who teach at your doorstep or online."
            matchTypes={["home tutor", "tutor"]}
            icon={Home}
        />
    );
}

export default HomeTutors;
